import { MILL_1 } from "@/setup/mill-config/mill-config";
import { routeDelaysManager } from "@/setup/routes/delay.routes";
import { routeM1StackerProduction } from "@/setup/routes/m1.routes";
import { MenuOptionType } from "@dexteel/mesf-core";
import { Inventory2, Memory } from "@mui/icons-material";

function isDelay(data: any) {
	return "delayId" in data;
}

function isCoolingBed(data: any) {
	return "isCoolingBed" in data;
}

export const useGanttOptionsFunctions = () => {
	const getMenuOptions = (data: any) => {
		let options: MenuOptionType[] = [];

		if (isDelay(data)) {
			options = options.concat([
				{
					name: "See in Manager",
					key: "see_delays_manager",
					onClick: () => {
						window.open(
							`${routeDelaysManager}/${data.shiftId}?assetId=${MILL_1.id}&delayId=${data.delayId}`,
							"_blank",
						);
					},
					icon: <Memory />,
				},
			]);
		}
		if (isCoolingBed(data)) {
			options = options.concat([
				{
					name: "See on Cooling Bed Prod.",
					key: "see_cooling_bed_production",
					onClick: () => {
						window.open(
							`${routeM1StackerProduction}/${data.shiftId}`,
							"_blank",
						);
					},
					icon: <Inventory2 />,
				},
			]);
		}

		return options;
	};
	return {
		getMenuOptions,
	};
};
